import { EditorState, RichUtils } from 'draft-js'

// The editor can briefly hold a stale selection whose start block no longer
// exists in the content (e.g. an atomic block was removed while a toolbar/menu
// was open). Draft.js methods like getCurrentInlineStyle() / getType() then
// dereference an undefined block and throw. Guard those reads with this check.
export const selectionBlockExists = (editorState: any): boolean => {
  if (!editorState) return false
  const selection = editorState.getSelection()
  return !!editorState.getCurrentContent().getBlockForKey(selection.getStartKey())
}

// A new embed can't be inserted while the cursor is on an embed (an atomic block), nor while the selection
// is stale (its block is gone): Draft.js would dereference the missing block.
export const selectionInAtomicBlock = (editorState: EditorState): boolean =>
  !selectionBlockExists(editorState) || RichUtils.getCurrentBlockType(editorState) === 'atomic'
